import { useState } from "react";
import Modal from "@/components/base/Modal";

interface BatchTargetModalProps {
  open: boolean;
  count: number;
  onClose: () => void;
  onSubmit: (targetUrl: string) => Promise<string | null>;
}

export default function BatchTargetModal({ open, count, onClose, onSubmit }: BatchTargetModalProps) {
  const [targetUrl, setTargetUrl] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    setTargetUrl("");
    setError("");
    onClose();
  };

  const handleSave = () => {
    void onSubmit(targetUrl).then((message) => {
      if (message) {
        setError(message);
        return;
      }
      handleClose();
    });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="批量修改目标网址"
      subtitle={`将应用到已选的 ${count} 个域名`}
      footer={
        <>
          <button
            type="button"
            onClick={handleClose}
            className="rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer whitespace-nowrap"
          >
            取消
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            确认修改
          </button>
        </>
      }
    >
      <label className="flex flex-col gap-2">
        <span className="font-label text-sm font-medium text-foreground-800">新的目标网址</span>
        <input
          type="text"
          value={targetUrl}
          onChange={(event) => setTargetUrl(event.target.value)}
          placeholder="https://你的目标页面地址"
          className="rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-500"
        />
      </label>
      {error ? (
        <div className="mt-3 flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2.5 text-sm text-secondary-900">
          <i className="ri-error-warning-line" />
          {error}
        </div>
      ) : null}
    </Modal>
  );
}
